import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";  
import { API_URL } from "../../constants/API_URL"; 
import { SinavRaporError } from "../../types/ErrorModals/SinavRaporError";
import { SinavSiralamaResponseModal, SinavYanlisAnaliziResponseModal, SinifVeSinavListesiResponseModal } from "../../types/modals";
import { SinavRaporRequestModal } from "../../types/RequestModals/SinavRaporRequestModal";
import { SinavRaporBaseRequestModal } from "../../types/RequestModals/SinavRaporBaseRequestModal";

export const getSinavSiralama = async (request: SinavRaporRequestModal): Promise<SinavSiralamaResponseModal> => {
  try {
    const response = await axios.post<ApiResponse<SinavSiralamaResponseModal>>(
      `${API_URL}/api/sinavRapor/getSinavSiralama`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Sınav sıralama raporu bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavRaporError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as SinavRaporError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as SinavRaporError;
    }
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as SinavRaporError;
  }
};

export const getSinavYanlisAnalizi = async (request: SinavRaporRequestModal): Promise<SinavYanlisAnaliziResponseModal> => {
  try {
    const response = await axios.post<ApiResponse<SinavYanlisAnaliziResponseModal>>(
      `${API_URL}/api/sinavRapor/getSinavYanlisAnalizi`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Sınav yanlış analizi raporu bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavRaporError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as SinavRaporError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as SinavRaporError;
    }
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as SinavRaporError;
  }
};

export const getSinifVeSinavListesi = async (request: SinavRaporBaseRequestModal): Promise<SinifVeSinavListesiResponseModal> => {
  try {
    const response = await axios.post<ApiResponse<SinifVeSinavListesiResponseModal>>(
      `${API_URL}/api/sinavRapor/getSinifVeSinavListesi`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Sınıf ve sınav listesi bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavRaporError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as SinavRaporError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as SinavRaporError;
    }
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as SinavRaporError;
  }
};